<template>
  <v-dialog max-width="500" @click:outside="closeModal">
    <v-card class="h-auto bg-white font-inter" :loading="loading">
      <div class="flex-col w-full px-4 pt-4 pb-2" v-if="!confirm">
        <h2 class="font-medium text-base mb-1">
          Unggah Form Keabsahan Saat Pengajuan
        </h2>
        <h6 class="font-normal text-xs text-gray-500">
          Untuk mengajukan laporan ESG ini, Anda perlu mengunggah Formulir
          Keabsahan terlebih dahulu sebagai bukti kelayakan dan kelengkapan
          dokumen.
        </h6>
      </div>
      <div class="flex items-center flex-col py-5" v-if="confirm">
        <img
          src="../../../assets/icon/confirm.png"
          alt="img confirm"
          class="w-44 h-auto py-5"
        />
        <h2 class="font-medium text-sm my-1">
          Apakah Anda yakin ingin mengajukan laporan ini?
        </h2>
        <h6 class="font-normal text-xs text-gray-500">
          Laporan akan segera diproses setelah diajukan.
        </h6>
      </div>
      <div class="relative mt-4 mx-2" v-else>
        <div
          class="border-2 border-dashed rounded-lg p-6 text-center transition-colors cursor-pointer flex items-center flex-col"
          :class="
            isDragging ? 'bg-gray-200 border-gray-500' : 'border-gray-300'
          "
          @click="triggerFileInput"
          @dragover.prevent="isDragging = true"
          @dragleave="isDragging = false"
          @drop.prevent="handleDrop"
        >
          <template v-if="!file">
            <img
              src="../../../assets/icon/folder.png"
              alt="icon folder"
              class="w-16 h-auto"
            />
            <p class="text-red-600 font-semibold text-sm">
              Pilih File
              <span class="text-gray-500 font-normal">
                atau seret file ke sini
              </span>
            </p>
          </template>
          <template v-else>
            <div class="flex items-center justify-center gap-2">
              <img
                src="../../../assets/icon/file.png"
                alt="icon file"
                class="w-4 h-auto"
              />
              <h5 class="font-semibold text-xs text-gray-800">
                {{ file?.name }}
              </h5>
            </div>
            <h5 class="font-normal text-gray-400 text-xs mt-3">
              {{ formatFileSize(file.size) }}
            </h5>
          </template>
          <input
            type="file"
            ref="fileInput"
            accept=".pdf,.docx"
            hidden
            @change="handleFileChange"
          />
        </div>
        <div class="absolute top-1 right-1" v-if="file">
          <i
            class="mdi mdi-close-circle-outline text-red-600 cursor-pointer text-2xl"
            @click="reset"
          ></i>
        </div>
        <p class="text-[10px] text-gray-400 mb-2 mx-2 text-right">
          Format: .PDF dan .DOCX (Ukuran maksimum: 50MB)
        </p>
      </div>
      <div class="flex justify-end items-center gap-2 border-t px-4 pb-4 pt-2">
        <v-btn
          variant="outlined"
          class="capitalize text-xs font-medium border-gray-400 text-gray-700"
          @click="closeModal()"
        >
          Cancel
        </v-btn>
        <v-btn
          variant="outlined"
          class="capitalize text-xs font-medium"
          :class="[
            file ? 'bg-red-600 text-white' : 'bg-gray-200 text-stone-400',
          ]"
          :disabled="!file && loading"
          @click="
            file && !confirm
              ? (confirm = true)
              : file && confirm
              ? submitFile()
              : ''
          "
        >
          {{ confirm ? "Ya, Ajukan" : "Unggah dan Ajukan" }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { upload } from "@/utilities/FileManager";
import { TypeFileEnum } from "@/utilities/enum";

export default {
  name: "SubmissionModal",
  data() {
    return {
      file: {},
      isDragging: false,
      confirm: false,
      loading: false,
    };
  },
  props: {
    dialog: Boolean,
    fileValidity: String,
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        const path = this.fileValidity;
        if (path) {
          Object.assign(this.file, {
            name: path.split("/").pop().split(")-").pop(),
          });
        } else {
          this.file = null;
        }
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
      this.confirm = false;
      this.file = null;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const selected = event.target.files[0];
      this.validateFile(selected);
    },
    handleDrop(event) {
      this.isDragging = false;
      const droppedFile = event.dataTransfer.files[0];
      this.validateFile(droppedFile);
    },
    validateFile(file) {
      if (!file) return;

      const allowedTypes = [
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      if (!allowedTypes.includes(file.type)) {
        alert("Hanya file PDF atau DOCX yang diperbolehkan.");
        file = null;
        return;
      }

      if (file.size > 50 * 1024 * 1024) {
        alert("Ukuran file melebihi 50MB.");
        file = null;
        return;
      }

      this.file = file;
    },
    reset() {
      this.file = null;
      this.$refs.fileInput.value = null;
    },
    async submitFile() {
      let fileName;
      if (this.file.size) {
        this.loading = true;
        const res = await upload(this.file, TypeFileEnum.ESG_REPORT);
        this.loading = false;
        fileName = res?.data?.filename || null;
      } else {
        fileName = this.fileValidity;
      }
      this.$emit("submission-data", fileName);
      this.closeModal();
    },
    formatFileSize(size) {
      const kb = size / 1024;
      if (size) {
        if (kb < 1024) {
          return `${kb.toFixed(1)} KB`;
        } else {
          return `${(kb / 1024).toFixed(2)} MB`;
        }
      } else {
        return "";
      }
    },
  },
  emits: ["submission-data"],
};
</script>
